<template>
  <div id='security'>
       <NavTop title='账号与安全'/>
       <van-cell-group inset>
       <van-cell title="登陆密码" value="去修改" is-link @click="go('/alterloginpsw')"/>
       <van-cell title="更换手机号" :value="mobile" is-link @click="go('altermobile')"/>
       <van-cell title="更多" is-link @click="go('/delaccount')"/>
     </van-cell-group>
  </div>
</template>
<script>
import {Cell, CellGroup } from 'vant'
import NavTop from '@/components/navtop'

export default {
   name: 'security',
   data() {
        return {
          mobile:''
        };
   }, 
   created(){
        this.getList(); 
   },
   methods: {
      getList(){
          this.$post("/user/getUserInfo",{}).then((data)=>{
            if(data.result.success){
              this.mobile=data.result.info.mobile
            }
        })
      },
      go(url){
        this.$go(url)
      }
   },
   components: {
        [Cell.name]:Cell,
        [CellGroup.name]:CellGroup,
        NavTop
   }
}
</script>
<style scoped>
#security{background-color:#F6F6F6;min-height: 100vh;}
::v-deep .van-cell__title{text-align: left;}
::v-deep .van-cell__value{text-align: right;}
.title-center{text-align: center!important;}
.title-right{text-align: right!important;}
::v-deep .van-cell-group--inset{margin:0 0.25rem;}

</style>